import { render, staticRenderFns } from "./PersonalSettings.vue?vue&type=template&id=29e840e0&scoped=true"
import script from "./PersonalSettings.vue?vue&type=script&lang=js"
export * from "./PersonalSettings.vue?vue&type=script&lang=js"
import style0 from "./PersonalSettings.vue?vue&type=style&index=0&id=29e840e0&prod&lang=scss&scoped=true"
import style1 from "./PersonalSettings.vue?vue&type=style&index=1&id=29e840e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e840e0",
  null
  
)

export default component.exports